import { Box } from "@material-ui/core";
import React from "react";
import { BreadcrumbPage } from "../../shared";
import { withStyles, makeStyles, useTheme } from "@material-ui/core/styles";
const useStyles = makeStyles((theme) => ({
  boxLayout: {
    backgroundColor: "#fff",
    boxShadow: "1px 1px 4px 1px #e0e0e0",
    borderRadius: 8,
  },
}));
export default function Orderkit() {
  const classes = useStyles();
  const BreadcrumbList = [{ name: "Order a Kit", url: "" }];
  return (
    <div>
      <Box pb={3} pt={0} mx={3} display="dlock">
        <BreadcrumbPage rows={BreadcrumbList} />
      </Box>
      <Box mx={3} className={classes.boxLayout}>
        <iframe
          src="https://kts.vpsveritas.com"
          style={{ width: "100%", height: "700px" }}
          class="ordersample"
          name="vps"
          scrolling="yes"
          frameborder="0"
          marginheight="0"
          marginwidth="0px"
          allowfullscreen
        ></iframe>
      </Box>
    </div>
  );
}
